export const authRoutes = ["/login", "/forgot-password", "/reset-password"];
